const domain = 'ecarjp.com';

export const environment = {
  production: true,
  fullDomain: `${domain}`,
  newsDomain: domain,
  staging: false,
  domain,
  lotSiteDomain: 'ecarjp',
  imageProxy: `https://prx.${domain}/`,
  managerDomain: 'https://manager.akebono.world',
  graphql: [
    {
      clientName: 'authentication',
      endpoint: `https://${domain}/auto/main`,
      fetchPolicy: 'cache-first',
    },
    {
      clientName: 'agreements',
      endpoint: `https://${domain}/auto/main`,
      fetchPolicy: 'cache-first',
    },
    {
      clientName: 'user-info',
      endpoint: `https://${domain}/auto/main`,
      fetchPolicy: 'cache-first',
    },
    {
      clientName: 'cars-default',
      endpoint: `https://${domain}/cars/default`,
      fetchPolicy: 'cache-first',
    },
    {
      clientName: 'auto-main',
      endpoint: `https://api.${domain}/auto/main`,
    },
    {
      clientName: 'auto-shared',
      endpoint: `https://api.${domain}/auto/shared`,
    },
    {
      clientName: 'calculator',
      endpoint: `https://${domain}/auto/calculator`,
      fetchPolicy: 'cache-first',
    },
    {
      clientName: 'currency-exchange',
      endpoint: `https://${domain}/auto/main`,
      fetchPolicy: 'cache-first',
    },
    {
      clientName: 'content',
      endpoint: `https://${domain}/content/auto-minimal`,
      fetchPolicy: 'cache-first',
    },
    {
      clientName: 'directory',
      endpoint: `https://${domain}/graphql/directory/common/open`,
    },
    {
      clientName: 'exchange-rate',
      endpoint: `https://${domain}/graphql/directory/exchange-rate/open`,
    },
    {
      clientName: 'shared-familiar',
      endpoint: `https://${domain}/graphql/ecarjp/shared/familiar`,
    },
    {
      clientName: 'stats-auto',
      endpoint: `https://${domain}/stats/auto`,
      fetchPolicy: 'cache-first',
      method: 'GET',
    },
  ],
  cognitoPool: {
    ClientId: '15n40ogef0of0ld47t300746cq',
    UserPoolId: 'us-east-1_Aw3GqMAsn',
  },
};
